import {useEffect} from "react";
import {getShopAdminDetailApi} from "../service/shopService";

export function useApplicationDetail(setters, shopId) {
  useEffect(() => {
    const response = async () => {
      if(shopId) {
        const data = await getShopAdminDetailApi(shopId);

        setters.setLoginId?.(data.loginId);
        setters.setShopName?.(data.shopName);
        setters.setRealName?.(data.realName);
        setters.setService?.(data.serviceTpcd);
        setters.setBizTp?.(data.bizTp);
        setters.setBizNo?.(data.brNum);
        setters.setCorpNo?.(data.crNum);
        setters.setCond?.(data.bizCon);
        setters.setItem?.(data.bizItem);
        setters.setShopTel?.(data.shopTel);
        setters.setRoad?.(data.addrRoad);
        setters.setAddressDetail?.(data.addrDetail);
        setters.setReptName?.(data.reptName);
        setters.setBirth?.(data.birth);
        setters.setReptTel?.(data.reptTel);
        setters.setEmail?.(data.shopEmail);
        setters.setDeliType?.(data.deliAppTp);
        setters.setBankType?.(data.bankTpcd);
        setters.setAcntHolder?.(data.acntHolder);
        setters.setBankAcnt?.(data.bankAcnt);
      }
    }
    response();
  }, [shopId]);
}